(function () {
  if (window.__amPmSerumGalleryInit) return;
  window.__amPmSerumGalleryInit = true;

  function markAdded(wrapper) {
    const btn = wrapper.querySelector('.cartx-add-to-cart:not(.plus)');
    if (!btn) return;
    wrapper.classList.add('cartx-is-added');
    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent.trim();
    if (btn.dataset.originalText) btn.textContent = 'ADDED TO CART';
    clearTimeout(wrapper._addedTimer);
    wrapper._addedTimer = setTimeout(function () {
      wrapper.classList.remove('cartx-is-added');
      btn.textContent = btn.dataset.originalText;
    }, 2500);
  }

  function watchAddedToCart(container) {
    container.querySelectorAll('.cartx-product-button-wrap').forEach(function (wrapper) {
      let wasLoading = false;
      new MutationObserver(function () {
        const loading = wrapper.classList.contains('cartx-button-loadding');
        if (loading) { wasLoading = true; }
        else if (wasLoading) { wasLoading = false; markAdded(wrapper); }
      }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    });
  }

  document.querySelectorAll('.am-pm-serum-intro, .am-pm-serum-details').forEach(watchAddedToCart);

  function currentMode() {
    return document.body.classList.contains('ampm-mode-pm') ? 'pm' : 'am';
  }

  function getVideosForMode(section, mode) {
    return [
      ...section.querySelectorAll(
        `.am-pm-serum-gallery__variant--${mode} video, .am-pm-serum-details__variant--${mode} video`
      )
    ];
  }

  function pauseVideos(section, mode) {
    getVideosForMode(section, mode).forEach((v) => v.pause());
  }

  function playVideos(section, mode) {
    getVideosForMode(section, mode).forEach((v) => {
      if (v.readyState === 0) { v.preload = 'auto'; v.load(); }
      v.play().catch(() => {});
    });
  }

  const sections = [
    ...document.querySelectorAll('.am-pm-serum-gallery, .am-pm-serum-details')
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          playVideos(entry.target, currentMode());
        }
      });
    },
    { rootMargin: '200px' }
  );

  sections.forEach((s) => observer.observe(s));

  document.addEventListener('ampm:mode-change', (e) => {
    const { mode } = e.detail;
    const prevMode = mode === 'am' ? 'pm' : 'am';
    sections.forEach((s) => {
      pauseVideos(s, prevMode);
      playVideos(s, mode);
    });
  });
})();
